import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Reporting() {
	return (
		<div>
			<div className="alt-font">
				<HelmetProvider>
					<Helmet>
						<title>ESG Reporting</title>
						<meta name="description" content="ESG Reporting" />
						<meta
							name="keywords"
							content="ESG , Nachhaltige, Analyse, Reporting , Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h2 id="reporting">ESG Reporting &amp;&nbsp;Communication</h2>
				<p>
					Unsere Beratung für ESG Reporting und Kommunikation bietet Unternehmen
					eine umfassende Unterstützung bei der Konzeption und Umsetzung ihrer
					Nachhaltigkeitsstrategie. Wir decken alle wichtigen Bereiche ab, von
					der Konzeption und Erstellung des Unternehmensreportings nach GRI oder
					anderen relevanten Standards bis hin zur Unterstützung bei der
					Offenlegung zur EU-Taxonomie.
				</p>
				<p>
					Unsere Experten helfen Ihnen bei der Erstellung eines
					Nachhaltigkeitsberichts, der detaillierte Informationen zu den Umwelt-
					und Sozialauswirkungen Ihres Unternehmens bereitstellt. Darüber hinaus
					unterstützen wir Sie bei der Erstellung einer Nichtfinanziellen
					Erklärung, die Ihre unternehmerischen Ziele und Verpflichtungen in
					Bezug auf ESG darstellt.
				</p>
				<p>
					Mit unserem Impact Reporting bieten wir Ihnen eine Möglichkeit, den
					Beitrag Ihres Unternehmens zur Lösung globaler Herausforderungen wie
					Klimawandel und sozialer Ungerechtigkeit zu messen und zu
					kommunizieren.
				</p>
				<p>
					Schließlich unterstützen wir Sie bei der Entwicklung einer
					Kommunikationsstrategie für ESG, um den Unternehmenswert aus Sicht von
					Investoren, Kunden und anderen Stakeholdern zu steigern. Wir sind
					überzeugt, dass eine transparente und effektive Kommunikation von
					ESG-Leistungen ein wichtiger Bestandteil einer erfolgreichen
					Nachhaltigkeitsstrategie ist.
				</p>
				<p>
					Lassen Sie uns gemeinsam Ihre Nachhaltigkeitsstrategie entwickeln und
					umsetzen, um einen positiven Einfluss auf unsere Umwelt und
					Gesellschaft zu haben.
				</p>
			</div>
		</div>
	);
}
